export function cropImage(cropper, options) {
  return new Promise(resolve => {
    cropper.getCroppedCanvas(options).toBlob(resolve)
  })
}
